import { z } from "zod";

/** The subject value that publishes a tool to every end-user, regardless of IdP group. */
export const CATALOG_SUBJECT_EVERYONE = "*";

const MAX_SUBJECT_LENGTH = 255;

/**
 * A published catalog entry: one `(subject -> tool_ref)` grant. `subject` is an
 * IdP group value or the literal `"*"` (everyone); `tool_ref` is the version-less
 * tool name, matching how gateways persist `allowed_tools`.
 */
export type ToolCatalogEntry = {
  id: string;
  project_id: string;
  subject: string;
  tool_ref: string;
  created_time: string;
};

export const catalogGrantCreateSchema = z.object({
  subject: z
    .string()
    .trim()
    .min(1, "Audience is required")
    .max(MAX_SUBJECT_LENGTH, "Audience is too long"),
  tool_refs: z.array(z.string()).min(1, "Select at least one tool"),
});

export type CatalogGrantCreateInput = z.infer<typeof catalogGrantCreateSchema>;

/** The bulk create payload: one subject, many tools, published in one request. */
export type CatalogEntryCreateRequest = {
  subject: string;
  tool_refs: string[];
};

/** Coordinator's bulk-publish result. */
export type CatalogBulkCreateResponse = {
  items: ToolCatalogEntry[];
  created: number;
  already_existed: number;
};

/** The bulk delete payload: remove many entries by id in one request. */
export type CatalogBulkDeleteRequest = {
  entry_ids: string[];
};
